"use client";
import LegacyGameCard from "@casino/legacy/client/shared/game/GameCard";
import GameThumb from "./GameThumb";

type Props = {
  game: GameFragment;
  big?: boolean;
  wide?: boolean;
  medium?: boolean;
  light?: boolean;
  isLiveRtp?: boolean;
  rtpField?: RtpField;
  href?: string;
  preloadImg?: boolean;
  showGrid?: boolean;
  isMinMaxBetVisible?: boolean;
  isCarousel?: boolean;
  eager?: boolean;
};

const GameCard: FC<Props> = (props) => {
  const gameHref = props.href ?? props.game.href ?? "";
  // The `wide`/`medium` carousel variants still route to the legacy card.
  if (props.wide || props.medium) {
    return <LegacyGameCard {...props} href={gameHref} />;
  }
  const { game, eager } = props;
  return <GameThumb game={game} eager={eager} href={gameHref} />;
};

export default GameCard;
